import {createSlice, PayloadAction, createAsyncThunk} from '@reduxjs/toolkit';
import axiosInstance from '../../utility/axiosInstance';
import {handleAxiosError} from "../../helpers/handleAxiosError";

export interface SecurityGroup {
    id: string;
    name: string;
    description: string;
    project: string;
    created_at: string;
    updated_at: string;

    [key: string]: any;
}

interface SecurityGroupsState {
    data: SecurityGroup[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: SecurityGroupsState = {
    data: [],
    status: 'idle',
    error: null,
};

export const fetchSecurityGroups = createAsyncThunk(
    'securityGroups/fetchSecurityGroups',
    async (_, {rejectWithValue}) => {
        try {
            const response = await axiosInstance.get('/v1/security_groups');
            return response.data;
        } catch (error) {
            console.error("Failed to fetch DNS:", error);
            return rejectWithValue(handleAxiosError(error));
        }
    }
);

const securityGroupsSlice = createSlice({
    name: 'securityGroups',
    initialState,
    reducers: {
        setSecurityGroups: (state, action: PayloadAction<SecurityGroup[]>) => {
            state.data = action.payload;
        },
        resetSecurityGroups: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSecurityGroups.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchSecurityGroups.fulfilled, (state, action: PayloadAction<SecurityGroup[]>) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSecurityGroups.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            });
    },
});

export const {setSecurityGroups, resetSecurityGroups} = securityGroupsSlice.actions;
export default securityGroupsSlice.reducer;